export const PRICE = 'price';
export const SCORE = 'score';
export const DEPARTURE_DATE_TAKE_OFF = 'departure-date-take-off';
export const DEPARTURE_DATE_LANDING = 'departure-date-landing';
export const RETURN_DATE_TAKE_OFF = 'return-date-take-off';
export const RETURN_DATE_LANDING = 'return-date-landing';
export const TRAVEL_TIME = 'travel-time';
